module.exports = __webpack_public_path__ + "static/media/actylis.6831be4e.png";